import React, { Component } from 'react';

import Dropdown from '../Dropdown';

export default class DateRangePicker extends Component {
  render() {
    let options = [
      {
        label: 'Today',
        value: 'day'
      },
      {
        label: 'This week',
        value: 'week'
      },
      {
        label: 'This month',
        value: 'month'
      },
      {
        label: 'This quarter',
        value: 'quarter'
      },
      {
        label: 'This year',
        value: 'year'
      }
    ];

    if (this.props.customRange) {
      options.push({
        label: 'Custom Range',
        value: 'absolute'
      });
    }
    if (this.props.customPeriod) {
      options.push({
        label: 'Custom Period',
        value: 'relative'
      });
    }

    return <Dropdown {...this.props} options={options} />;
  }
}
